import { ConfigSource } from "./config-source";

export class JsonConfigSource<T = Record<string, unknown>> implements ConfigSource<T> {
  name = "JsonConfigSource";
  jsonConfig = {} as T;

  constructor(
    jsonConfig: Record<string, unknown>,
    readonly priority = 10,
  ) {
    this.jsonConfig = jsonConfig as T;
  }

  async initialize(): Promise<void> {}

  async getConfigValue<K extends keyof T>(key: K): Promise<T[K] | undefined> {
    return this.jsonConfig[key];
  }

  async getAllConfigValues(): Promise<T> {
    return this.jsonConfig;
  }
}
